import {useEvent} from 'Event/EventProvider'
import {useObieMilestones} from 'lib/event-api/integrations/obie/milestones/list'
import Select from 'lib/ui/Select'
import Option from 'lib/ui/Select/Option'
import {useOrganization} from 'organization/OrganizationProvider'
import React from 'react'

export interface MilestoneSelectProps {
  obieJourneyId: string
  value: string | null
  onChange: (obieMilestoneId: string | null) => void
  disabled?: boolean
}

export default function MilestoneSelect(props: MilestoneSelectProps) {
  const {obieJourneyId, value, onChange, disabled} = props
  const {event} = useEvent()
  const {client} = useOrganization()
  const {data: milestones = [], isLoading, error} = useObieMilestones({
    client,
    event,
    obieJourneyId,
  })

  if (isLoading) {
    return (
      <Select
        label="Milestone"
        aria-label="milestone"
        value=""
        onChange={() => {}}
        displayEmpty
        disabled
        fullWidth
      >
        <Option value="">Loading…</Option>
      </Select>
    )
  }

  if (error) {
    return (
      <Select
        label="Milestone"
        aria-label="milestone"
        helperText={error.message}
        error
        value=""
        onChange={() => {}}
        disabled
        fullWidth
      />
    )
  }

  const isSavedMilestoneMissing =
    Boolean(value) && !milestones.some((milestone) => milestone.id === value)

  return (
    <Select
      label="Milestone"
      aria-label="milestone"
      value={value ?? ''}
      onChange={(event) => onChange(String(event.target.value) || null)}
      disabled={disabled}
      displayEmpty
      fullWidth
    >
      <Option value="">Whole journey</Option>
      {isSavedMilestoneMissing && (
        <Option value={value} disabled>
          No longer available
        </Option>
      )}
      {milestones.map((milestone) => (
        <Option key={milestone.id} value={milestone.id}>
          {milestone.name}
        </Option>
      ))}
    </Select>
  )
}
